import type { DepotReleves, ReleveEnregistre } from '../types';

/**
 * En accès libre, les relevés restent dans le navigateur, à part de l'état
 * de démonstration : un relevé pèse plus lourd qu'une étape.
 */
const CLE = 'vla-demo-releves';

function lireTous(): Record<string, ReleveEnregistre> {
  try {
    const brut = localStorage.getItem(CLE);
    return brut ? (JSON.parse(brut) as Record<string, ReleveEnregistre>) : {};
  } catch {
    return {};
  }
}

/** Pour la fiche de l'étape : le relevé est-il complet ? */
export function releveCompletDemo(etapeId: string): boolean {
  return lireTous()[etapeId]?.complet ?? false;
}

/** Pour la fiche de l'étape : un relevé est-il commencé ? */
export function releveCommenceDemo(etapeId: string): boolean {
  return lireTous()[etapeId] !== undefined;
}

export const relevesDemo: DepotReleves = {
  lire(etapeId) {
    return Promise.resolve(lireTous()[etapeId] ?? null);
  },

  enregistrer(etapeId, donnees, complet) {
    const tous = lireTous();
    const enregistre: ReleveEnregistre = {
      donnees: structuredClone(donnees),
      complet,
      version: (tous[etapeId]?.version ?? 0) + 1,
      majLe: new Date().toISOString(),
    };
    tous[etapeId] = enregistre;
    try {
      localStorage.setItem(CLE, JSON.stringify(tous));
    } catch {
      return Promise.reject(new Error('Le navigateur est plein : relevé non enregistré.'));
    }
    return Promise.resolve(enregistre);
  },
};
